import storage from '~/utils/storage';

export const RECENT_LIMIT = 3;

function storageKey(userId: number): string {
    return `quick_nav_recent_${userId}`;
}

export function getRecentPaths(userId: number): string[] {
    const raw = storage.getItem(storageKey(userId));
    if (!raw) return [];
    try {
        const parsed = JSON.parse(raw) as unknown;
        if (!Array.isArray(parsed)) return [];
        return parsed.filter((p): p is string => typeof p === 'string').slice(0, RECENT_LIMIT);
    } catch {
        return [];
    }
}

export function pushRecentPath(userId: number, path: string, allowedPaths: Set<string>): string[] {
    if (!allowedPaths.has(path)) {
        return getRecentPaths(userId);
    }

    const next = [path, ...getRecentPaths(userId).filter((p) => p !== path)].slice(0, RECENT_LIMIT);
    storage.setItem(storageKey(userId), JSON.stringify(next));
    return next;
}
